import CoreComponent from '../../core/CoreComponent.vue';
import AccessibilityHelper from '../../../../helpers/accessibility-helper';
export default {
  extends: CoreComponent,
  mounted() {
    AccessibilityHelper.generateAriaLabelForBannerButton(this.cmpEl, ".cmp-caseStudyBanner__title", ".cmp-caseStudyBanner__button a");
  }
};